// src/pages/Documentos/EditarAta.js
import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarAta from "./CadastrarAta";

const EditarAta = () => {
    const { id } = useParams();

    return <CadastrarAta ataId={id} />;
};

export default EditarAta;
